import * as actionTypes from './actionTypes';

export const setTeamToUpdate=(team)=>({
    type:actionTypes.SET_TEAM_TO_UPDATE,
    payload:team
})